import { assign } from 'xstate'
import ApiFetcher from 'lib/api_fetcher'
import {nextStep} from 'utils/step_utils'
import {EUR} from 'utils/currency'
import i18n from 'i18n/config'

const setError = assign({error: i18n.t('validations:fill_all_fields')})
const cleanError = assign({error: null})
const setValidationError = assign({error: i18n.t('validations:pickups_required')})
const quoteUpdateForm = assign({quote_form: (ctx, e) => e.form})

const setQuotationResources = assign({resources: (ctx, e) => e.data})

const fetchQuotationResources = (ctx) => {
  return (
    new ApiFetcher({
      key: 'events',
      endpoint: ctx.endpoints.quotation_resources,
      query: {date: ctx.day}
    }).call()
  )
}

const submitForm = async (ctx, event, params) => {
  const purchaseInfo = params.product.purchase_info
  const form = ctx.quote_form

  const locations = [
    ...(purchaseInfo.places || []),
    purchaseInfo.accommodation,
  ].filter(Boolean)

  const mapLocation = (value) => {
    const location = locations.find((item) => item.value === value)

    if (!location) {
      throw new Error(`No se encuentra la ubicación: ${value}`)
    }

    return {
      value: location.value,
      code: location.code,
      type: location.type,
    }
  }

  await form.submitForm()

  const errors = await form.validateForm()

  if (Object.keys(errors).length > 0) {
    throw errors
  }

  const values = ctx.quote_form.values

  return {
    ...values,
    pickup: mapLocation(values.pickup),
    dropoff: mapLocation(values.dropoff),
  }
}

const quoteState = (steps, params, step) => {
  // console.log('quote')
  // console.log(params)

  return {
    initial: 'init',
    states: {
      init: {
        on: {'': {
          target: 'waitingQuotationParams',
          actions: cleanError
        }},
      },
      // prepareFetchingResources: {
      //   on: {'': {
      //     target: 'fetchingResources',
      //     actions: ['startSpinner']
      //   }},
      // },
      // fetchingResources: {
      //   invoke: {
      //     src: fetchQuotationResources,
      //     onDone: {
      //       target: 'waitingQuotationParams',
      //       actions: [setQuotationResources, 'stopSpinner']
      //     },
      //     onError: {
      //       target: '#purchase.error',
      //       actions: [setError, 'stopSpinner']
      //     }
      //   },
      // },
      waitingQuotationParams: {},
      formValidation: {
        invoke: {
          src: (ctx, event) => submitForm(ctx, event, params),
          onDone: [
            {
              target: step.target,
              actions: assign({[step.currentStep + '_values']: (ctx, e) => e.data})
            }
          ],
          onError: {
            target: 'waitingQuotationParams',
            actions: [setError]
          }
        }
      }
    },
    on: {
      QUOTE_FORM_CHANGE: {
        actions: [quoteUpdateForm]
      },
      NEXT_STEP_CLICK: [
        {
          target: '.formValidation'
        },
        {
          actions: [setValidationError]
        }
      ]
    }
  }
}

export default quoteState
